// using ES6 modules
// import lozad from "lozad";
import GLightbox from "glightbox";

export default class Gallery {
  constructor() {
    this.galleries = document.querySelectorAll(".js-gallery");
  }

  init() {
    this.initGalleries();
  }

  initGalleries() {
    var lightbox = GLightbox({
      selector: ".js-gallery",
      width: "90vw",
      height: "90vh",
    });
    // this.navItems.forEach(el => {
    //   el.addEventListener("mouseenter", this.enterItem);
    //   el.addEventListener("mouseleave", this.leaveItem);
    // });
    // this.navItems.forEach(el => {
    //   el.addEventListener("mouseenter", this.enterItem);
    //   el.addEventListener("mouseleave", this.leaveItem);
    // });
  }

  events() {
    // this.navItems.forEach(el => {
    //   el.addEventListener("mouseenter", this.enterItem);
    //   el.addEventListener("mouseleave", this.leaveItem);
    // });
  }

  render() {
    //
  }
}



// WEBPACK FOOTER //
// ./scripts/components/gallery.js